export const STAGES = ["nouveau", "a_qualifier", "qualifie", "contact_autorise", "contacte",
  "reponse_recue", "rendez_vous", "proposition_envoyee", "negociation", "gagne", "perdu"];

export const STAGE_LABELS = {
  nouveau: "Nouveau", a_qualifier: "À qualifier", qualifie: "Qualifié",
  contact_autorise: "Contact autorisé", contacte: "Contacté", reponse_recue: "Réponse reçue",
  rendez_vous: "Rendez-vous", proposition_envoyee: "Proposition envoyée",
  negociation: "Négociation", gagne: "Gagné", perdu: "Perdu",
};

export const STAGE_COLORS = {
  nouveau: "bg-slate-100 text-slate-700", a_qualifier: "bg-amber-50 text-amber-700",
  qualifie: "bg-badge text-sky-700", contact_autorise: "bg-badge text-sky-700",
  contacte: "bg-badge text-sky-700", reponse_recue: "bg-badge text-sky-700",
  rendez_vous: "bg-badge text-sky-700", proposition_envoyee: "bg-badge text-sky-700",
  negociation: "bg-amber-50 text-amber-700", gagne: "bg-emerald-50 text-emerald-700",
  perdu: "bg-red-50 text-red-700",
};

export const PROVINCES = ["AB", "BC", "MB", "NB", "NL", "NS", "NT", "NU", "ON", "PE", "QC", "SK", "YT"];

export const COMPANY_TYPES = [["prospect", "Prospect"], ["client_actif", "Client actif"]];

export const ACTIVITY_TYPES = [["note", "Note"], ["appel", "Appel"], ["courriel", "Courriel"], ["rencontre", "Rencontre"], ["autre", "Autre"]];

const stageOptions = STAGES.map((s) => [s, STAGE_LABELS[s]]);
const provinceOptions = PROVINCES.map((p) => [p, p]);

export const MODULES = {
  companies: {
    title: "Entreprises",
    endpoint: "/crm/companies",
    entityParam: "company_id",
    singular: "entreprise",
    searchPlaceholder: "Rechercher (nom, ville, courriel)…",
    importable: true,
    archivable: true,
    filters: [
      { key: "type", label: "Type", options: COMPANY_TYPES },
      { key: "province", label: "Province", options: provinceOptions },
    ],
    columns: [
      { key: "name", label: "Entreprise", bold: true },
      { key: "sector", label: "Secteur" },
      { key: "province", label: "Prov." },
      { key: "city", label: "Ville" },
      { key: "type", label: "Type", badge: COMPANY_TYPES },
      { key: "last_interaction_at", label: "Dernière interaction", date: true },
      { key: "next_action_date", label: "Prochaine action", date: true },
    ],
    formFields: [
      { key: "name", label: "Nom de l'entreprise", required: true },
      { key: "sector", label: "Secteur" },
      { key: "province", label: "Province", type: "select", options: provinceOptions },
      { key: "city", label: "Ville" },
      { key: "website", label: "Site web" },
      { key: "phone", label: "Téléphone", type: "tel" },
      { key: "email", label: "Courriel", type: "email" },
      { key: "type", label: "Type", type: "select", options: COMPANY_TYPES, default: "prospect" },
      { key: "source", label: "Source" },
      { key: "next_action_date", label: "Prochaine action", type: "date" },
      { key: "notes", label: "Notes", type: "textarea", full: true },
    ],
  },
  contacts: {
    title: "Contacts",
    endpoint: "/crm/contacts",
    entityParam: "contact_id",
    singular: "contact",
    searchPlaceholder: "Rechercher (nom, courriel, fonction)…",
    importable: true,
    archivable: true,
    needsCompanies: true,
    columns: [
      { key: "name", label: "Nom", bold: true },
      { key: "company_name", label: "Entreprise" },
      { key: "title", label: "Fonction" },
      { key: "email", label: "Courriel", link: "mailto" },
      { key: "phone", label: "Téléphone", link: "tel" },
      { key: "consent_status", label: "Consentement", consent: true },
    ],
    formFields: [
      { key: "name", label: "Nom complet", required: true },
      { key: "company_id", label: "Entreprise", type: "entity" },
      { key: "title", label: "Fonction" },
      { key: "email", label: "Courriel", type: "email" },
      { key: "phone", label: "Téléphone", type: "tel" },
      { key: "notes", label: "Notes", type: "textarea", full: true },
    ],
  },
  leads: {
    title: "Leads",
    endpoint: "/crm/leads",
    entityParam: "lead_id",
    singular: "lead",
    newLabel: "Nouveau lead",
    searchPlaceholder: "Rechercher (entreprise, contact, courriel)…",
    importable: true,
    archivable: true,
    filters: [
      { key: "status", label: "Étape", options: stageOptions },
      { key: "source", label: "Source contient…", free: true },
    ],
    columns: [
      { key: "company_name", label: "Entreprise", bold: true },
      { key: "contact_name", label: "Contact" },
      { key: "email", label: "Courriel", link: "mailto" },
      { key: "source", label: "Source" },
      { key: "status", label: "Étape", stage: true },
      { key: "next_action_date", label: "Prochaine action", date: true },
      { key: "created_at", label: "Créé le", datetime: true },
    ],
    formFields: [
      { key: "company_name", label: "Nom de l'entreprise", required: true },
      { key: "contact_name", label: "Contact professionnel" },
      { key: "contact_title", label: "Fonction" },
      { key: "email", label: "Courriel", type: "email" },
      { key: "phone", label: "Téléphone", type: "tel" },
      { key: "website", label: "Site web" },
      { key: "sector", label: "Secteur" },
      { key: "province", label: "Province", type: "select", options: provinceOptions },
      { key: "city", label: "Ville" },
      { key: "source", label: "Source du lead", required: true },
      { key: "verified_at", label: "Date de vérification", type: "date" },
      { key: "identified_need", label: "Besoin identifié", type: "textarea", full: true },
      { key: "status", label: "Étape du pipeline", type: "select", options: stageOptions, default: "nouveau" },
      { key: "next_action_date", label: "Prochaine action", type: "date" },
      { key: "notes", label: "Notes", type: "textarea", full: true },
    ],
  },
  opportunities: {
    title: "Opportunités",
    endpoint: "/crm/opportunities",
    entityParam: "opportunity_id",
    singular: "opportunité",
    searchPlaceholder: "Rechercher (titre)…",
    importable: true,
    archivable: true,
    needsCompanies: true,
    needsContacts: true,
    filters: [{ key: "stage", label: "Étape", options: stageOptions }],
    columns: [
      { key: "title", label: "Opportunité", bold: true },
      { key: "company_name", label: "Entreprise" },
      { key: "stage", label: "Étape", stage: true },
      { key: "amount", label: "Montant ($)", money: true },
      { key: "expected_close_date", label: "Clôture prévue", date: true },
      { key: "created_at", label: "Créé le", datetime: true },
    ],
    formFields: [
      { key: "title", label: "Titre de l'opportunité", required: true },
      { key: "company_id", label: "Entreprise", type: "entity", required: true },
      { key: "contact_id", label: "Contact", type: "entity" },
      { key: "stage", label: "Étape du pipeline", type: "select", options: stageOptions, default: "nouveau" },
      { key: "amount", label: "Montant estimé ($ CAD)", type: "number" },
      { key: "expected_close_date", label: "Date de clôture prévue", type: "date" },
      { key: "notes", label: "Notes", type: "textarea", full: true },
    ],
  },
  tasks: {
    title: "Tâches",
    endpoint: "/crm/tasks",
    entityParam: "company_id",
    singular: "tâche",
    searchPlaceholder: "Rechercher (titre)…",
    importable: false,
    archivable: false,
    needsCompanies: true,
    inlineStatus: true,
    columns: [
      { key: "title", label: "Tâche", bold: true },
      { key: "due_date", label: "Échéance", date: true, overdue: true },
      { key: "status", label: "Statut", stage: true },
      { key: "notes", label: "Notes" },
    ],
    formFields: [
      { key: "title", label: "Titre de la tâche", required: true },
      { key: "due_date", label: "Échéance", type: "date", required: true },
      { key: "company_id", label: "Entreprise liée", type: "entity" },
      { key: "lead_id", label: "Lead lié", type: "entity" },
      { key: "notes", label: "Notes", type: "textarea", full: true },
    ],
  },
};

export const TASK_STATUS = [["a_faire", "À faire"], ["terminee", "Terminée"]];

export const CONSENT_LABELS = {
  "": "Non établi", expresse: "Expresse", implicite: "Implicite (24 mois)", desabonne: "Désabonné",
};

export const MOON_STATUS_LABELS = {
  nouvelle: "Nouvelle", en_analyse: "En analyse", recherche_fournisseur: "Recherche fournisseur",
  devis_recu: "Devis reçu", devis_envoye: "Devis envoyé", acceptee: "Acceptée",
  commande_en_cours: "Commande en cours", livree: "Livrée", annulee: "Annulée",
};

export const INQUIRY_STATUS_LABELS = {
  brouillon: "Brouillon", en_attente_validation: "En attente de validation", prete_a_envoyer: "Prête à envoyer",
  envoyee: "Envoyée", reponse_recue: "Réponse reçue", relance_necessaire: "Relance nécessaire",
  sans_reponse: "Sans réponse", refusee: "Refusée", terminee: "Terminée",
};

export const INQUIRY_STATUS_COLORS = {
  en_attente_validation: "bg-amber-50 text-amber-700", prete_a_envoyer: "bg-badge text-sky-700",
  envoyee: "bg-badge text-sky-700", reponse_recue: "bg-emerald-50 text-emerald-700",
  relance_necessaire: "bg-amber-50 text-amber-700", sans_reponse: "bg-slate-100 text-slate-600",
  refusee: "bg-red-50 text-red-700", terminee: "bg-emerald-50 text-emerald-700",
  brouillon: "bg-slate-100 text-slate-600",
};
